/* eslint-disable */
import { cn } from '@netlify/ui';

import type { AlertState } from '../Alert/types.js';

import type { AlertSmallVariants } from './types.js';

const STATES: Partial<
  Record<AlertState, { className: string; iconClassName?: string }>
> = {
  error: { className: 'tw-text-red-darkest dark:tw-text-red-lightest' },
  warning: { className: 'tw-text-gold-darkest dark:tw-text-gold-lighter' },
  info: {
    className: 'tw-text-black dark:tw-text-gray-lightest',
    iconClassName: 'tw-text-gray-dark dark:tw-text-gray-light',
  },
  success: { className: 'tw-text-teal-darkest dark:tw-text-teal-lightest' },
};

const VARIANTS: Record<AlertSmallVariants, string> = {
  'form-field': 'tw-mx-0.5 tw-text-sm tw-my-1 tw-leading-6 tw-font-regular',
};

export const alertCN = ({
  outset,
  state,
  variant,
  className,
}: {
  outset?: string | undefined;
  state?: AlertState | undefined;
  variant?: "form-field" | undefined;
  className?: string | undefined;
}) =>
  cn(
    'tw-relative tw-max-w-170 tw-pl-6 tw-text-left',
    outset,
    state && STATES[state]?.className,
    variant && VARIANTS[variant],
    className
  );

export const iconCN = ({ state, iconClassName }: { state?: AlertState | undefined; iconClassName?: string | undefined }) =>
  cn('tw-absolute tw-left-0', state && STATES[state]?.iconClassName, iconClassName);

export const contentsCN = 'tw-c-alert-small tw-overflow-visible';
